module.exports = __webpack_public_path__ + "static/media/dragon_1.0336680b.jpg";